import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

import theme from 'theme_'
import AuditEmail from './auditEmail'

const StyledExternalLink = styled.a`
  font-size: 1em;
  color: ${theme.colors.darkestGrey};
  text-decoration: none;

  &:hover,
  :active,
  :focus {
    text-decoration: underline;
  }
`

export const StyledAuditEmail = styled(StyledExternalLink)`
  text-transform: lowercase;
  word-wrap: break-word;
  word-break: break-word;

  &:hover,
  &:active,
  &:focus {
    color: ${theme.colors.black};
  }
`

export const AuditTableOuterWrapper = styled.div`
  overflow-x: auto;
`

export const AuditTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: 960px;
  }
`

const orangeTextStyle = css`
  text-transform: capitalize;
  color: ${theme.colors.horizonOrange};
  word-break: initial;

  &:hover,
  :active,
  :focus {
    color: ${theme.colors.horizonOrange};
  }
`

export const AuditOrangeEmail = styled(AuditEmail)`
  ${orangeTextStyle};
`

export const AuditOrangeText = styled.span`
  ${orangeTextStyle};
  text-transform: none;
`

export const StyledLink = styled(Link)`
  font-size: 1em;
  color: ${theme.colors.black};
  text-decoration: none;

  &:hover,
  :active,
  :focus {
    color: ${theme.colors.black};
    text-decoration: underline;
  }
`

export const AuditTableCellText = styled.span`
  > a {
    text-transform: capitalize;
    color: ${theme.colors.horizonOrange};
    word-break: initial;

    &:hover,
    :active,
    :focus {
      color: ${theme.colors.horizonOrange};
    }
  }
`
